import React from 'react';
import { Typography, Skeleton } from '@mui/material';
import cx from 'classnames';
import { ReactComponent as SourceIcon } from 'new/components/icons/fi-rr-exit.svg';
import { ReactComponent as DestinationIcon } from 'new/components/icons/fi-rr-arrow-right-to-bracket.svg';
import { ReactComponent as MemberIcon } from 'new/components/icons/fi-rr-users.svg';
import { ReactComponent as NexsetsIcon } from 'new/components/icons/fi-rr-apps.svg';
import styles from './ResourceTile.module.scss';
import FormatUtils from 'js/lib/FormatUtils';

interface ResourceTileProps {
  type: string;
  title: string;
  subtitle: string;
  value: number;
  isLoading: boolean;
  borderColor?: string;
}

const ICON_MAP = {
  sources: SourceIcon,
  destinations: DestinationIcon,
  members: MemberIcon,
  nexsets: NexsetsIcon,
};

export const ResourceTile = (props: ResourceTileProps) => {
  const { type, title, subtitle, value, isLoading, borderColor = 'blue' } = props;
  const IconComponent = ICON_MAP[type];

  if (isLoading) {
    return (
      <div className={cx(styles.tile, styles[`tile--${borderColor}`])}>
        <Skeleton variant="rounded" width={32} height={32} />
        <Skeleton variant="text" width={60} height={36} />
        <Skeleton variant="text" width={120} height={20} />
        <Skeleton variant="text" width={140} height={16} />
      </div>
    );
  }

  return (
    <div className={cx(styles.tile, styles[`tile--${borderColor}`])}>
      <div className={styles.tileIcon}>
        <IconComponent />
      </div>
      <Typography variant="h3" className={styles.tileValue}>
        {FormatUtils.formatNamedNumber(value)}
      </Typography>
      <Typography variant="bodyDefault" className={styles.tileTitle}>
        {title}
      </Typography>
      <Typography variant="bodySmall" className={styles.tileSubtitle}>
        {subtitle}
      </Typography>
    </div>
  );
};
